export const DIRECTIONS: Record<string, ('N' | 'S' | 'E' | 'W')[]> = {
  latitude: ['N', 'S'],
  longitude: ['E', 'W'],
};
